<template>
    <div class="common-body-view">
        <div  class="common-title">
            <van-icon @click="back" name="arrow-left" color="#5e5e5e" size="20"/>
            <span class="common-title-text">连点器</span>
        </div>

        <div class="main">
            <div class="main-body">
                <div v-if="planList.length > 0">
                    <div v-for="(item,index) in planList" style="display: flex;align-items: center;justify-content: space-between;padding: 15px 10px;background-color: #f2f2f2;margin-top: 3px;border-radius: 4px;">
                        <div style="font-size: 14px;color: #333333;font-weight: bold;">
                            {{index + 1}}. {{item.name}}
                        </div>
                        <div style="font-size: 12px;color: #ee4e4e;user-select: none;display: flex;align-items: center;">

                            <van-icon @click="deletePlan(index)" name="cross" style="cursor: pointer;" size="18"/>

                            <img @click="enablePlan(index)"  src="../assets/ldq/run.png" style="width: 22px;height: 22px;cursor: pointer;margin-left: 5px;">

                        </div>
                    </div>
                </div>

                <div v-else style="font-size: 14px;color: #888888;margin-top: 30px;text-align: center;">
                    暂无数据
                </div>

            </div>

            <div style="width: 100%; text-align: right;height: 30px;box-sizing: border-box;">
                <div @click="createPlan" style="color: #f16868;font-size: 13px;margin-top: 10px;">
                    创建新的连点器场景<van-icon name="arrow" />
                </div>
                <!--                <van-button  @click="createPlan" type="info" round :loading="showLoading" style="height: 30px;width: 100px;font-size: 13px;margin-top: 6px;" color="#e73d50">
                                    创建新场景
                                </van-button>-->
            </div>

        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Toast,Dialog } from 'vant';

    export default {
        name: "auto-click-setting",
        components: {
        },
        data() {
            return {
                showLoading: false,
                parent: this.$parent.$parent,
                planList: [],
            }
        },
        mounted () {
            this.planList = JSON.parse(localStorage.getItem('autoClickPlanList')) || [];
        },
        methods: {
            back(){
                this.parent.autoClickListShow = false;
            },
            createPlan() {
                this.parent.createNewAutoClickPlan();
            },
            enablePlan(index) {
                this.parent.enableAutoClickPlan(index);
            },
            deletePlan(index) {
                Dialog.confirm({
                    message: '是否要删除?',
                }).then(() => {
                    this.planList.splice(index, 1);
                    localStorage.setItem('autoClickPlanList', JSON.stringify(this.planList));
                    Toast('删除成功');

                }).catch(() => {
                });
            },

        }
    }
</script>

<style scoped>
    .common-body-view {
        border-radius: 10px;
        width: 100%;
        height: 320px;
        box-sizing: border-box;
        max-width: 400px;
        position: relative;
        margin: 0 auto;
    }

    .common-title {
        height: 50px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        padding-left: 15px;
    }

    .common-title-text {
        font-size: 16px;
        font-weight: bold;
        margin-left: 8px;
        color: #5e5e5e;
    }

    .main{
        width: 95%;
        height: 265px;
        border-radius: 5px;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 5px 5px;
        box-sizing: border-box;
        position: relative;
    }
    .main-body {
        width: 100%;
        //padding: 0 5px 15px;
        box-sizing: border-box;
        height: 230px;
        overflow-y: auto;
        text-align: left;
    }

    .main-body {
        -ms-overflow-style: none;  /* IE 和 Edge */
        scrollbar-width: none;/* Firefox */
    }
    .main-body::-webkit-scrollbar {
        display: none;/* 兼容 Chrome, Opera, 和 Safari */
    }

    .input-view{
        width: 100%;
        height: 38px;
        border-radius: 5px;
        display: flex;
        margin-top: 8px;
        border: 0.5px solid #e0e0e0;
        //box-shadow: 2px 2px 10px 3px rgba(0,0,0,.1);
    }
    .common-input {
        font-size: 14px;
        height: 38px;
        border-radius: 5px;
    }

    .van-cell {
        padding: 7px 10px;
    }
    /deep/ .van-field__control {
        color: #333333;
    }
    .van-cell::after {
        border-bottom: none;
    }

</style>